import React, { useState, useContext } from 'react';
import { AppContext } from '~/providers/AppProvider';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { Button, Checkbox } from '@boatsetter-backup/js-component-lib';
import { Trans, withI18n } from '@lingui/react';
import { t } from '@lingui/macro';

const DurationFilter = ({ setShowDurationFilter, i18n }) => {
  const DURATIONS = [
    {
      label: `${i18n._(t`charterTypeDuration.dayCharter`)}`,
      value: 'DayCharter',
    },

    {
      label: `${i18n._(t`charterTypeDuration.multiDayCharter`)}`,
      value: 'MultiDayCharter',
    },

    {
      label: `${i18n._(t`charterTypeDuration.weekCharter`)}`,
      value: 'WeekCharter',
    },
  ];

  const router = useRouter();
  const appCtx = useContext(AppContext);

  const [duration, setDuration] = useState(
    router.query.duration === undefined ? [] : JSON.parse(String(router.query.duration))
  );

  const pushDuration = () => {
    setShowDurationFilter(false);
    appCtx.actions.setLoading(true);

    const currentQueries = router.query;
    delete currentQueries.pageNumber;

    if (duration.length === 0) {
      clearDuration();
    } else {
      router.replace(
        {
          pathname: router.pathname,
          query: {
            ...currentQueries,
            duration: JSON.stringify(duration),
          },
        },
        undefined,
        { scroll: false }
      );
    }
  };

  const clearDuration = () => {
    setShowDurationFilter(false);

    setDuration([]);
    const currentQueries = router.query;

    delete currentQueries.duration;
    delete currentQueries.pageNumber;

    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...currentQueries,
        },
      },
      undefined,
      { scroll: false }
    );
  };

  const modifyDuration = (durationValue) => {
    const arr = duration;
    if (arr.includes(durationValue)) {
      arr.splice(arr.indexOf(durationValue), 1);
    } else {
      arr.push(durationValue);
    }

    setDuration(arr);
  };

  return (
    <Wrapper>
      <FiltersWrapper>
        <CheckBoxWrapper>
          {DURATIONS.map((d) => (
            <DurationCheckboxWrapper>
              <Checkbox
                key={d.value}
                defaultChecked={duration.includes(d.value)}
                name={d.label}
                id={d.value}
                label={d.label}
                onChange={() => {
                  modifyDuration(d.value);
                }}
                owner={true}
                bold={true}
              />
            </DurationCheckboxWrapper>
          ))}
        </CheckBoxWrapper>
      </FiltersWrapper>

      <FilterBottomBar>
        <Clear onClick={clearDuration}>
          Clear duration
          {/* <Trans id="moreFilters.clearAll" /> */}
        </Clear>
        <Button small={true} onClick={pushDuration} text={<Trans id="moreFilters.seeResults" />} />
      </FilterBottomBar>
    </Wrapper>
  );
};

const DurationCheckboxWrapper = styled.div`
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0px;
  }
`;
const FiltersWrapper = styled.div`
  padding: 3em;

  button {
    background: transparent;
    outline: none;
    border: none;
  }
`;

const Wrapper = styled.div`
  width: 300px;
  height: auto;
  position: absolute;
  background-color: white;
  border: 1px solid #dbdfe5;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  top: 55px;

  @media (max-width: 960px) {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    width: 92%;
    overflow-x: hidden;
  }
`;

const FilterBottomBar = styled.div`
  height: 90px;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 22px -2px rgba(0, 0, 0, 0.2);
  padding: 2em;

  button span {
    font-size: 12px !important;
    font-family: AvenirNext, Avenir, Helvetica Neue, Helvetica, Arial, sans-serif;
  }
`;

const Clear = styled.div`
  font-size: 1em;
  line-height: 1.6;
  color: #0751c2;
  cursor: pointer;
`;

const CheckBoxWrapper = styled.div`
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  min-height: 25px;
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0px;
  }

  input {
    border: 1px solid #dbdfe5 !important;
    border-radius: 3px;
    background: white !important;
    cursor: pointer;
    width: 22px;
    height: 22px;
    margin-right: 16px;
  }

  input:checked {
    background-color: #0751c2 !important;
    border: 1px solid #0751c2 !important;

    &:after {
      left: 0;
      width: 4px;
      height: 8px;
      width: 4px;
      height: 10px;
      border-color: white !important;
    }
  }

  input:checked + label {
    /* color: #0751c2 !important; */
    color: #17233c !important;
  }
  input + label {
    color: #17233c;
    font-weight: 300;
    cursor: pointer;
  }
`;

export default withI18n()(DurationFilter);
